export default __webpack_public_path__ + "static/media/95a504df508d129f.d9882aa22609e6d3d8f46b18e2264e5a.svg";